// import jsPDF from "jspdf";
import { getS3ImageSrc, getpdfgeneratesrc } from ".";

// export const getS3ImageSrc = (name) => {
//     if(name){
//       var url = `${ASSETS_URI}/${name}`
//       return url;
//     }else{
//       return ""
//     }
//   };

// export const fetchImage = async (pdf,size=0) => {
//   try {

//     // const pdf = this.props.pdf;

//     if (pdf) {
//       const url = await getpdfgeneratesrc(1, size,pdf); // Define your getpdfgeneratesrc function
//       const parts = url.split('/');

//       return parts

//     }
//   } catch (error) {
//     // Handle any errors that occur during the fetch
//     console.error('Error fetching image source:', error);
//   }
// };

/**==========================================================JSPDF====================================================================== */
// import jsPDF from "jspdf";

export const generatePDFFromImages = async (urldata, images, Curresntpdf) => {
  const jsPDF = await import("jspdf");
  let pdf = null;

  const loadImage = (imageUrl) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imageUrl;

      img.onload = () => resolve(img);
      img.onerror = reject;
    });

  const renderImageToCanvas = (image, width, height) =>
    new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, width, height);
      resolve(canvas);
    });

  for (const imageUrl of images) {
    try {
      const image = await loadImage(
        getS3ImageSrc(
          window.__E_TT_Client.companySlug,
          urldata,
          parseInt(imageUrl),
          "image-1.jpg",
          Curresntpdf
        )
      );

      // Page size follows the image's own pixel dimensions instead of A4.
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      const orientation = width >= height ? "landscape" : "portrait";

      const canvas = await renderImageToCanvas(image, width, height);
      const imageData = canvas.toDataURL("image/jpeg");

      if (!pdf) {
        pdf = new jsPDF.default({
          orientation,
          unit: "px",
          format: [width, height],
          hotfixes: ["px_scaling"],
        });
      } else {
        pdf.addPage([width, height], orientation);
      }

      pdf.addImage(
        imageData,
        "JPEG",
        0,
        0,
        width,
        height,
        null,
        "FAST" // You can try using "FAST" or "SLOW" compression options
      );
    } catch (error) {
      console.error("Error processing image:", error);
    }
  }

  if (!pdf) {
    console.error("No images could be added to the PDF");
    return;
  }

  pdf.save("images.pdf");
};

/**==========================================================PDF LIB====================================================================== */

// import { PDFDocument,rgb } from "pdf-lib";

// export const generatePDFFromImages = async (urldata, images) => {
//   const pdfDoc = await PDFDocument.create();
//   for (const imageUrl of images) {
//     try {
//       const url = getS3ImageSrc(window.__E_TT_Client.companySlug, urldata, parseInt(imageUrl), "image-1.jpg");

//       const imageBytes = await loadImage(url);

//       const image = await pdfDoc.embedPng(imageBytes);
//       const page = pdfDoc.addPage([image.width, image.height]);
//       const { width, height } = page.getSize();

//       page.drawImage(image, {
//         x: 0,
//         y: 0,
//         width,
//         height,
//       });

//     } catch (error) {
//       console.error("Error loading or embedding an image:", error);
//       // You can choose to skip the image or handle the error as needed.
//     }
//   }


//   const pdfBytes = await pdfDoc.save();
//   saveAsPdf(pdfBytes, "images.pdf"); // You'll need a function to save the PDF, e.g., using FileSaver.js
// };

// const loadImage = (imageUrl) => {
//   return new Promise((resolve, reject) => {
//     fetch(imageUrl)
//       .then((response) => response.arrayBuffer())
//       .then((data) => resolve(data))
//       .catch(reject);
//   });
// };

function saveAsPdf(data, filename) {
  const blob = new Blob([data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
